import { render, staticRenderFns } from "./privilegesAndExemptions.vue?vue&type=template&id=0bfe6eb5&scoped=true&"
import script from "./privilegesAndExemptions.vue?vue&type=script&lang=js&"
export * from "./privilegesAndExemptions.vue?vue&type=script&lang=js&"
import style0 from "./privilegesAndExemptions.vue?vue&type=style&index=0&id=0bfe6eb5&scoped=true&lang=css&"
import style1 from "./privilegesAndExemptions.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfe6eb5",
  null
  
)

export default component.exports